import React, { useRef } from 'react'
import DevExtremeFileManager, { ContextMenu, Item } from 'devextreme-react/file-manager'
import 'devextreme/dist/css/dx.light.css'
import CustomFileSystemProvider from 'devextreme/file_management/custom_provider'
import { Auth, Storage } from 'aws-amplify'
import gql from 'graphql-tag'
import { useApolloClient } from '@apollo/client'
import { downloadFromUrl } from 'helpers/downloadFromUrl'

const upload = gql`
	query getPresignedUploadUrl($key: String) {
	  getPresignedUploadUrl(key: $key)
	}
`
const download = gql`
	query  getPresignedDownloadUrl($key: String) {
	   getPresignedDownloadUrl(key: $key)
	}
`
const FileManager = ({ sendRequest }) => {
	const client = useApolloClient()

	const getItems = async ({ dataItem, pathKeys, key }) => {
		const response = await sendRequest({
			command: 'FILE_STRUCTURE',
			path: key
		})
		return response.body
	}

	const deleteItem = async ({ key }) => {
  		return sendRequest({
			command: 'DELETE_FILE',
			path: key
		})
	}

	const downloadItems = async ([item]) => {
		const timeStampHash = (+new Date()).toString(36)

		const resultUpload = await client.query({
			query: upload,
			variables: { key: `${timeStampHash}_${item.name}` }
		})

		await sendRequest({
			command: 'UPLOAD_FILE',
			url: resultUpload?.data?.getPresignedUploadUrl,
			path: item.key
		})

		const resultDownload = await client.query({
			query: download,
			variables: { key: `${timeStampHash}_${item.name}` }
		})
		return downloadFromUrl(resultDownload?.data?.getPresignedDownloadUrl, item.name)
	}

	const uploadFileChunk = async (fileData, chunksInfo, { key }) => {
		const keyBase = (await Auth.currentSession()).getIdToken().payload['custom:company'].replace(/-/g, '_')
		const timeStampHash = (+new Date()).toString(36)
		const result = await Storage.put(`kinesis_files/${keyBase}/${timeStampHash}_${fileData.name}`, fileData, {
			level: 'private',
			contentType: fileData.type,
			expires: Math.floor(Date.now() / 1000) + 60 * 3
		})
		const signedURL = await Storage.get(result.key, {
			level: 'private'
		})
		return sendRequest({
			command: 'DOWNLOAD_FILE',
			url: signedURL,
			path: `${key}/${fileData.name}`
		})
	}


	const fs = useRef(new CustomFileSystemProvider({
		getItems,
		deleteItem,
		downloadItems,
		uploadFileChunk
	}))


	return(
		<DevExtremeFileManager
			fileSystemProvider={fs.current}
			selectionMode='multiple'
			upload={{
				maxFileSize: 100000000,
				chunkSize: 0
			}}
			permissions={{
				create: false,
				copy: false,
				move: false,
				delete: true,
				rename: false,
				upload: true,
				download: true
			}}
			notifications={{
				showPanel: true
			}}
		>
			<ContextMenu>
				<Item name='upload' text='Upload' visible/>
				<Item name='download' text='Download' visible/>
				<Item name='delete' text='Delete' visible/>
				<Item name='refresh'/>
			</ContextMenu>
		</DevExtremeFileManager>
	)
}

export default FileManager
